import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-950
                    flex items-center
                    justify-center text-center px-4">
      <div>

        {/* 404 Number */}
        <div className="text-9xl font-bold
                        text-blue-900/50 mb-4
                        font-mono">
          404
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold
                       text-blue-200 mb-4">
          Page Not Found
        </h1>

        {/* Description */}
        <p className="text-gray-500 mb-8
                      max-w-md mx-auto">
          The page you're looking for doesn't exist.
          Let's get you back on track!
        </p>

        {/* Buttons */}
        <div className="flex items-center
                        justify-center gap-4">
          <Link
            to="/"
            className="bg-gray-800
                       hover:bg-gray-700
                       text-gray-300
                       font-semibold
                       px-6 py-3 rounded-xl
                       border border-gray-700
                       transition-colors">
            Go Home
          </Link>

          <Link
            to="/generator"
            className="flex items-center gap-2
                       bg-blue-600
                       hover:bg-blue-500
                       text-white font-semibold
                       px-6 py-3 rounded-xl
                       transition-colors">
            <Zap className="w-4 h-4" />
            Try Generator
          </Link>
        </div>

      </div>
    </div>
  );
};

export default NotFoundPage;